/**
 * useConversationVoicePlayer — la lecture d'un message vocal du fil, un seul à la fois : le lecteur
 * commun (`ui/hooks/useVoicePlayer`), que les gestes du fil désignent par leur message. Changer de fil
 * (`threadId`) arrête tout.
 */
import { useCallback } from "react"

import { useVoicePlayer } from "../../../hooks/useVoicePlayer"
import { type UIConversationMessage } from "../../../types/studentConversation"

export function useConversationVoicePlayer(threadId: string | null) {
    const player = useVoicePlayer(threadId)
    const { toggle: toggleVoice, seek: seekVoice, cycleRate: cycleVoiceRate } = player

    const toggle = useCallback(
        (message: UIConversationMessage) => {
            if (message.attachment?.kind === "voice") toggleVoice(message.id, message.attachment.uri)
        },
        [toggleVoice]
    )
    const seek = useCallback(
        (message: UIConversationMessage, ratio: number) => seekVoice(message.id, ratio),
        [seekVoice]
    )
    const cycleRate = useCallback((message: UIConversationMessage) => cycleVoiceRate(message.id), [cycleVoiceRate])

    return { ...player, toggle, seek, cycleRate }
}
